
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/remyndBrandPartnerMap",
      function () {
        return require("private-next-pages/remyndBrandPartnerMap/index.tsx");
      }
    ]);
  